module.exports = __webpack_public_path__ + "img/2.51a4ab06.png";